import ContentView from "Components/ContentView/ContentView";
import * as React from "react";
import styles from "./AuditTemplateBlockOverview.scss";
import AuditTemplateBlockOverviewHeader from "./AuditTemplateBlockOverviewHeader/AuditTemplateBlockOverviewHeader";
import AuditTemplateBlockView from "./AuditTemplateBlockView/AuditTemplateBlockView";
import AuditTemplateFilters from "./AuditTemplateFilters/AuditTemplateFilters";
import AuditTemplateSearch from "./AuditTemplateSearch/AuditTemplateSearch";

const AuditTemplateBlockOverview: React.FunctionComponent<{}> = () => (
    <ContentView>
        <AuditTemplateBlockOverviewHeader />
        <AuditTemplateSearch />
        <div className={styles.flexWrapper}>
            <AuditTemplateFilters />
            <AuditTemplateBlockView />
        </div>
    </ContentView>
);

export default AuditTemplateBlockOverview;


// WEBPACK FOOTER //
// ./src/Components/Pages/AuditTemplateBlockOverview/AuditTemplateBlockOverview.tsx